export default "__VITE_ASSET__TJufDdvr__"